import { Col, PageHeader } from 'antd';
import { FC, useState } from 'react';
import {
  MainContainer,
  LeftCol,
} from 'app/components/LayoutComponents/LayoutComponents';
import GarageTabs from '../../parts/GarageTabs/GarageTabs';
import {
  GarageTabKeyType,
  IEmployeeFilters,
  ITransportFilters,
} from '../../types';
import { useTranslation } from 'react-i18next';
import TransportCard from '../../parts/TransportCard/TransportCard';
import TransportFilters from '../../parts/TransportFilters/TransportFilters';
import ImplementCard from '../../parts/ImplementCard/ImplementCard';
import EmployeeCard from '../../parts/EmployeeCard/EmployeeCard';
import { matchPath, useLocation } from 'react-router-dom';
import { RouteConstants } from 'app/routes';
import EmployeeFilters from '../../parts/EmployeeFilters/EmployeeFilters';

interface IProps {}

const GaragePage: FC<IProps> = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const getSelectedKey = (): GarageTabKeyType | undefined => {
    const isTransport = matchPath(
      location.pathname,
      RouteConstants.garage.transportList,
    );
    if (isTransport) {
      return 'transport';
    }

    const isEmployee = matchPath(
      location.pathname,
      RouteConstants.garage.employeeList,
    );
    if (isEmployee) {
      return 'employee';
    }
    const isImplement = matchPath(
      location.pathname,
      RouteConstants.garage.implementList,
    );
    if (isImplement) {
      return 'implement';
    }
  };
  const selectedKey = getSelectedKey();

  const [transportFilters, setTransportFilters] = useState<ITransportFilters>(
    {},
  );

  const [employeeFilters, setEmployeeFilters] = useState<IEmployeeFilters>({});

  return (
    <>
      <PageHeader
        className="page-header"
        title={t('Garage.PageTitle', 'Inventory')}
      />
      <MainContainer>
        <LeftCol>
          <GarageTabs selectedKey={selectedKey} />
          {selectedKey === 'transport' || selectedKey === 'implement' ? (
            <TransportFilters
              onFiltersChange={setTransportFilters}
              filters={transportFilters}
            />
          ) : selectedKey === 'employee' ? (
            <EmployeeFilters
              filters={employeeFilters}
              onFiltersChange={setEmployeeFilters}
            />
          ) : null}
        </LeftCol>
        <Col flex={1}>
          {selectedKey === 'transport' ? (
            <TransportCard filters={transportFilters} />
          ) : selectedKey === 'implement' ? (
            <ImplementCard filters={transportFilters} />
          ) : selectedKey === 'employee' ? (
            <EmployeeCard filters={employeeFilters} />
          ) : null}
        </Col>
      </MainContainer>
    </>
  );
};

export default GaragePage;
